
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/competition",
      function () {
        return require("private-next-pages/competition/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/competition"])
      });
    }
  